import React from "react";
import TableHeader from "../../Components/Table/TableHeader";
import TableBody from "../../Components/Table/TableBody";

const Tree = ({
  groupedCategories,
  updatedCategoriesTableListView,
  isLoadingData,
  isVTEX,
}) => {
  return (
    <>
      <table className="table">
        <TableHeader tableHeaderList={updatedCategoriesTableListView} />
      </table>
      <div className="accordion" id="categoriesAccordion">
        {Object.keys(groupedCategories).map((parentKey, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
              <button
                className={`accordion-button ${
                  isVTEX ? "vtex-accordion" : ""
                } collapsed`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded="true"
                aria-controls={`collapse-${index}`}
              >
                {parentKey === "undefined"
                  ? `Undefined (${groupedCategories[parentKey].length})`
                  : `${groupedCategories[parentKey][0].parent_id[1]} (${groupedCategories[parentKey].length})`}
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className={`accordion-collapse collapse ${
                index === 0 ? "hide" : ""
              }`}
              aria-labelledby={`heading-${index}`}
              data-bs-parent="#categoriesAccordion"
            >
              <div className="accordion-body">
                <table className="table">
                  <thead style={{ display: "none" }}>
                    <TableHeader
                      tableHeaderList={updatedCategoriesTableListView}
                    />
                  </thead>
                  <TableBody
                    tableData={groupedCategories[parentKey]}
                    tableBodyList={updatedCategoriesTableListView}
                    isLoadingData={isLoadingData}
                    checkIsLoadingData
                  />
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Tree;
